import { render, staticRenderFns } from "./backtop.vue?vue&type=template&id=71a859fc&"
import script from "./backtop.vue?vue&type=script&lang=js&"
export * from "./backtop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports